import React from "react";
import { useEffect, useState } from "react";
import LeagueStanding from "../LeagueStanding";
import StandingService from "@/services/standingService";
import { LEAGUES_PLUGINS } from "@/contants";
import CupStanding from "../CupStanding";
import { Link } from "@/lib/target";
import {Image} from "@/lib/target/";
import ADD from "@/assets/images/Add.svg";
import SUBTRACT from "@/assets/images/Subtract.svg";
import LoadingInner from "@/app/loadingInner";
import NoData from "../NoData";

const StandingFilter = ({league}) => {  

  const disableNav = league ? true : false;
  if (!league) {
    league = LEAGUES_PLUGINS[0].id;
  }
  const [data, setData] = useState(null);
  const [type, setType] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [activeLeague, setActiveLeague] = useState(league);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (activeLeague) {
        setLoading(true);
        const response = await StandingService.getLeaguesStanding(activeLeague);
        setData(response.data.result);
        setType(response.data.type);
        setLoading(false);
      }
    };

    fetchData();
  }, [activeLeague]);
  
  if (!data || type === null) return <NoData />;

  const handleClick = (e, id) => {
    e.preventDefault();
    setActiveLeague(id);
  };  

  const activeClass = `bg-button-blue-bet @lg:bg-transparent text-white @lg:text-button-blue-bet px-1 @lg:p-0 py-1 rounded`;
  const activeMdClass = `font-semibold relative @lg:before:absolute before:left-0 before:h-0.5 before:-bottom-1 before:w-full before:bg-button-blue-bet z-1`;

  return (
    <div className="standing-list rounded w-full mx-auto @lg:px-2">
      <div className={`bg-button-blue-bet w-full rounded-lg my-2 px-2 @lg:px-7 @md:flex hidden ${disableNav ? '@md:hidden' : ''}`}>
        <div className={`relative text-xs border-b border-transparent z-2 bg-white rounded justify-between overflow-hidden transition-all duration-500 ${isOpen ? 'shadow h-28 w-full !overflow-y-scroll @lg:!overflow-hidden' : 'h-6 @lg:h-8 w-5/6'}`}>
          <ul id="tabs" className="absolute h-28 flex flex-wrap pr-8 pl-2 w-full @xl:w-[980px]">
            {LEAGUES_PLUGINS.slice(0, 20).map((item, index) => (
              <li key={item.id} className="flex items-center justify-center h-6 @lg:h-8 text-xxs @lg:text-xs">
                <Link
                  onClick={(e) => handleClick(e, item.id)}
                  className={`cursor-pointer text-gray-800 ${ activeLeague === item.id ? `${activeMdClass} ${activeClass}` : '' }`}
                >
                  {item.name || item.vn}
                </Link>
                <div className={`mx-1.5 @lg:mx-3 pb-1 h-4 border-solid border-l`}></div>
              </li>
            ))}
          </ul>
          <div className="absolute w-6 h-6 @lg:w-8 @lg:h-8 top-0 right-0 bg-white flex items-center justify-center">
            <button className="" onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <Image alt="Net88" src={SUBTRACT}/> : <Image alt="Net88" src={ADD} />}
            </button>
        </div>
        </div>
      </div>
      <div className={`@md:hidden w-full ${disableNav ? 'hidden' : ''}`}> 
        <LeaguesDropdownPlugin leagues={LEAGUES_PLUGINS} leagueId={activeLeague} handleClick={handleClick}/>
      </div>

      <div className="relative min-h-24">
        {loading ? (<LoadingInner/>) : (
          <div id="tab-contents">
            {type === 1 ? (
              <LeagueStanding standings={data} leagueId={{id:activeLeague}}/>
            ) : (
              <CupStanding data={data} leagueId={{id:activeLeague}}/>
            )}
          </div>
        )}
      </div>
    </div>
  );
};


const LeaguesDropdownPlugin = ({ leagues, leagueId, handleClick}) => {
  
  const [selectedSeason, setSelectedSeason] = useState(leagueId);

  const handleSelect = (event) => {
    const selectedValue = event.target.value;
    handleClick(event, selectedValue)
    setSelectedSeason(selectedValue);
  };

  return (
    <div className="flex items-center my-4 px-1 w-full">
      <select
        id="season-dropdown"
        className="p-2 rounded shadow-md w-full border border-button-blue-bet text-center"
        value={selectedSeason}
        onChange={handleSelect}
      >
        {leagues.map((item, index) => (
          <option key={index} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default React.memo(StandingFilter);
